import { defineMessages } from 'react-intl';

const scope = 'app.containers.CalculationForms';

export default defineMessages({
    // group displacement calc
    saveYourWork: {
        id: `${scope}.saveYourWork`,
        description: 'Save title',
        defaultMessage: 'Save your work',
    },
    createSave: {
        id: `${scope}.createSave`,
        description: 'Create save button title',
        defaultMessage: 'Create a new save',
    },
    updateSave: {
        id: `${scope}.updateSave`,
        description: 'Update save button title',
        defaultMessage: 'Update my save',
    },
    cancelButton: {
        id: `${scope}.cancelButton`,
        description: 'Cancel button title',
        defaultMessage: 'Cancel',
    },
    retryButton: {
        id: `${scope}.retryButton`,
        description: 'Retry button title',
        defaultMessage: 'Retry',
    },
    saveError: {
        id: `${scope}.saveError`,
        description: 'Message when save fails',
        defaultMessage: `Sorry, we couldn't save your work. Please try again later.`,
    },
    alertMessage: {
        id: `${scope}.alertMessage`,
        description: 'Alert message when save fails',
        defaultMessage: `Sorry, something went wrong`,
    },
    groupDispTitle: {
        id: `${scope}.groupDispTitle`,
        description: 'Group Displacement Calculator Title',
        defaultMessage: `Group Displacement Calculator`,
    },
    grpStepOneTitle: {
        id: `${scope}.grpStepOneTitle`,
        description: 'Group Displacement Step One Title',
        defaultMessage: `Step One - Tell us how your hotel normally behaves`,
    },
    grpStepTwoTitle: {
        id: `${scope}.grpStepTwoTitle`,
        description: 'Group Displacement Step Two Title',
        defaultMessage: `Step Two - Now tell us about the group`,
    },
    grpStepThreeTitle: {
        id: `${scope}.grpStepThreeTitle`,
        description: 'Group Displacement Step Three Title',
        defaultMessage: `Step Three - Finally, tell us about the group’s additional spend`,
    },
    calcMinRateButton: {
        id: `${scope}.calcMinRateButton`,
        description: 'Calculate minimum rate button label',
        defaultMessage: `Calculate Min Rate`,
    },
    outcomeBreakEven: {
        id: `${scope}.outcomeBreakEven`,
        description: 'Outcome part 1',
        defaultMessage: `We calculate the break-even point per room per night to be`,
    },
    outcomePartTwo: {
        id: `${scope}.outcomePartTwo`,
        description: 'Outcome part 2',
        defaultMessage: `Based on the groups current budget you will`,
    },
    outcomePartThree: {
        id: `${scope}.outcomePartThree`,
        description: 'Outcome part 3',
        defaultMessage: `per room per night. Therefore, our recommendation is to {value} this group at the current budget.`,
    },
    grossRevEstimate: {
        id: `${scope}.grossRevEstimate`,
        description: 'Label for the gross revenue estimate',
        defaultMessage: `The GROSS Revenue estimated is:`,
    },
    nettRevEstimate: {
        id: `${scope}.nettRevEstimate`,
        description: 'Label for the nett figures',
        defaultMessage: `The figures below show the impact to your hotel based on NETT values:`,
    },
    acceptingGroupLabel: {
        id: `${scope}.acceptingGroupLabel`,
        description: 'Label for the accepting figures',
        defaultMessage: `Accepting the group:`,
    },
    rejectingGroupLabel: {
        id: `${scope}.rejectingGroupLabel`,
        description: 'Label for the rejecting figures',
        defaultMessage: `Not accepting the group:`,
    },
    budgetPRPNLabel: {
        id: `${scope}.budgetPRPNLabel`,
        description: 'Group budget label',
        defaultMessage: `Group Budget PRPN`,
    },
    groupName: {
        id: `${scope}.groupName`,
        description: 'Group name',
        defaultMessage: `Group name`,
    },
    stayDatesLabel: {
        id: `${scope}.stayDatesLabel`,
        description: 'Stay dates label',
        defaultMessage: `Stay dates`,
    },
    notes: {
        id: `${scope}.notes`,
        description: 'notes',
        defaultMessage: `Notes`,
    },
    washLabel: {
        id: `${scope}.washLabel`,
        description: 'Label for group wash input',
        defaultMessage: `Apply group wash?`,
    },
    washTipOne: {
        id: `${scope}.washTipOne`,
        description: 'First line of wash tooltip',
        defaultMessage: `Apply this if you think that the total number of group rooms may not actually materialise`,
    },
    washTipTwo: {
        id: `${scope}.washTipTwo`,
        description: 'Second line of wash tooltip',
        defaultMessage: `e.g. 10% may cancel, therefore the Group Wash would be 10%`,
    },
});
